export const environment = {
  production: true
};



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/environments/environment.ts